import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { firstValueFrom, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private http = inject(HttpClient);

  async getToPromise<T>(path: string): Promise<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(this.http.get<T>(endpointCompleteUrl, { headers: this.buildHeaders() }).pipe(
      take(1)
    ));
  }

  getToObs<T>(path: string): Observable<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return this.http.get<T>(endpointCompleteUrl, { headers: this.buildHeaders() });
  }

  async getBlobToPromise(path: string): Promise<Blob> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(
      this.http.get(endpointCompleteUrl, {
        headers: this.buildHeaders(),
        responseType: 'blob'
      }).pipe(take(1))
    );
  }

  async postToPromise<T>(path: string, body: string): Promise<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(this.http.post<T>(endpointCompleteUrl, body, { headers: this.buildHeaders() }).pipe(
      take(1)
    ));
  }

  postToObs<T>(path: string, body: string): Observable<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return this.http.post<T>(endpointCompleteUrl, body, { headers: this.buildHeaders() });
  }

  async postBlobToPromise(path: string, body: string): Promise<Blob> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(
      this.http.post(endpointCompleteUrl, body, {
        headers: this.buildHeaders(),
        responseType: 'blob'
      }).pipe(take(1))
    );
  }

  async put<T>(path: string, body: string): Promise<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(this.http.put<T>(endpointCompleteUrl, body, { headers: this.buildHeaders() }).pipe(
      take(1)
    ));
  }

  async putFormData<T>(path: string, formData: FormData): Promise<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(this.http.put<T>(endpointCompleteUrl, formData, { headers: this.buildHeaders(false) }).pipe(
      take(1)
    ));
  }

  async delete<T>(path: string): Promise<T> {
    const endpointCompleteUrl = `${environment.apiURL}${path}`;
    return await firstValueFrom(this.http.delete<T>(endpointCompleteUrl, { headers: this.buildHeaders() }).pipe(
      take(1)
    ));
  }

  private buildHeaders(addJsonContentType?: boolean): HttpHeaders {
    const jwt = localStorage.getItem('jwt');
    let headers = new HttpHeaders();
    headers = headers.append('jwt', jwt ?? '');
    if (addJsonContentType ?? true) {
      headers = headers.append('Content-Type', 'application/json');
    }
    return headers;
  }
}
